'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditUser = exports.EditUserSubaccount = exports.NewUser = exports.NewSubAccountUser = exports.UsersList = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp, _dec3, _dec4, _class4, _desc2, _value2, _class5, _class6, _temp2, _dec5, _dec6, _class7, _desc3, _value3, _class8, _class9, _temp3, _dec7, _dec8, _class10, _desc4, _value4, _class11, _class12, _temp4, _dec9, _dec10, _class13, _desc5, _value5, _class14, _class15, _temp5;

var _components = require('components');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = require('redux/modules/auth');

var _subaccountUsers = require('redux/modules/subaccountUsers');

var _users = require('redux/modules/users');

var _roles = require('redux/modules/roles');

var _subaccounts = require('redux/modules/subaccounts');

var _Account = require('../Account/Account');

var _Account2 = _interopRequireDefault(_Account);

var _Allow = require('../Allow/Allow');

var _Allow2 = _interopRequireDefault(_Allow);

var _Snackbar = require('../../components/Snackbar/Snackbar');

var _Snackbar2 = _interopRequireDefault(_Snackbar);

var _index = require('../../../node_modules/@material-ui/icons/index');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRouter = require('react-router');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _Snackbar3 = require('@material-ui/core/Snackbar');

var _Snackbar4 = _interopRequireDefault(_Snackbar3);

var _translations = require('translations');

var _translations2 = _interopRequireDefault(_translations);

var _reduxConnect = require('redux-connect');

var _coreDecorators = require('core-decorators');

var _reactRedux = require('react-redux');

var _status = require('redux/modules/status');

var _themeEnabled = require('helpers/themeEnabled');

var _reachHistory = require('../../helpers/reachHistory');

var _Users = require('./Users.scss');

var _Users2 = _interopRequireDefault(_Users);

var _useBasename = require('../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

var _featureEnabled = require('helpers/featureEnabled');

var _StyledPhoneInput = require('../../components/StyledPhoneInput/StyledPhoneInput');

var _StyledPhoneInput2 = _interopRequireDefault(_StyledPhoneInput);

var _account2 = require('../../redux/modules/account');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var md = {
  search: require('react-icons/lib/md/search'),
  person: require('react-icons/lib/md/person'),
  personAdd: require('react-icons/lib/md/person-add'),
  message: require('react-icons/lib/md/email'),
  delete: require('react-icons/lib/md/delete'),
  tag: require('react-icons/lib/md/label'),
  upload: require('react-icons/lib/md/file-upload'),
  moreVert: require('react-icons/lib/md/more-vert'),
  gesture: require('react-icons/lib/md/label-outline'),
  file: require('react-icons/lib/md/attachment'),
  carretClose: require('react-icons/lib/md/keyboard-arrow-right'),
  carretOpen: require('react-icons/lib/md/keyboard-arrow-down'),
  edit: require('react-icons/lib/md/edit'),
  arrowBack: require('react-icons/lib/md/arrow-back'),
  warning: require('react-icons/lib/md/warning')

  //#region LISTA DE USUARIOS
};var UsersList = exports.UsersList = (_dec = (0, _reduxConnect.asyncConnect)([{
  key: "auth",
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    if (!(0, _auth.isLoaded)(getState())) {
      return dispatch((0, _auth.load)());
    }
    return null;
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    mobileMode: state.mobile.mobileMode,
    selected: state.users.selected,
    list: state.users.list,
    isLoading: state.users.loading,
    account: state.auth.current_account,
    auth: state.auth.data
  };
}, {
  get: _users.getAccountUsers,
  select: _users.userSelect,
  unselect: _users.userUnselect,
  refresh: _users.usersRefresh,
  usersUnselectAll: _users.usersUnselectAll,
  deleteUsers: _users.deleteUsers,
  pushState: _reachHistory.push,
  getAccountRoles: _roles.getAccountRoles
}), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_List) {
  (0, _inherits3.default)(UsersList, _List);

  function UsersList(props) {
    (0, _classCallCheck3.default)(this, UsersList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (UsersList.__proto__ || (0, _getPrototypeOf2.default)(UsersList)).call(this, props));

    _this.title = (0, _translations2.default)('USERS');
    var account = _this.props.account;
    return _this;
  }

  (0, _createClass3.default)(UsersList, [{
    key: 'deleteSelected',
    value: function deleteSelected() {
      var _this2 = this;

      this.props.selected.map(function (pos) {
        if (_this2.props.auth.user.id !== _this2.props.list[pos]._id) {
          _this2.props.deleteUsers(_this2.props.list[pos]._id, _this2.props.account.account_uid).then(function () {
            _this2.props.refresh();
            _this2.props.get();
          });
        }
      });
    }
  }, {
    key: 'editUser',
    value: function editUser() {
      var user_id = this.props.list[this.props.selected[0]]._id;

      this.props.pushState({
        pathname: '/user/edit/' + user_id,
        state: {
          returnTo: '/users/',
          editUser: this.props.list[this.props.selected[0]]
        }
      });
    }
  }, {
    key: 'isSelecting',
    value: function isSelecting() {
      return this.props.selected.length !== 0;
    }
  }, {
    key: 'renderListHeader',
    value: function renderListHeader() {
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(_Users2.default);
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: _Users2.default.listheader },
          _react2.default.createElement(
            'div',
            { className: _Users2.default.container },
            _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)("USERS LIST") }),
            _react2.default.createElement('div', { className: _Users2.default.checkBoxColumn }),
            _react2.default.createElement(
              'div',
              { className: _Users2.default.email },
              (0, _translations2.default)('EMAIL')
            ),
            _react2.default.createElement(
              'div',
              { className: _Users2.default.name },
              (0, _translations2.default)('FIRST_NAME')
            ),
            _react2.default.createElement(
              'div',
              { className: _Users2.default.role },
              (0, _translations2.default)('ROLES')
            ),
            _react2.default.createElement(
              'div',
              { className: _Users2.default.status },
              (0, _translations2.default)('STATUS')
            ),
            _react2.default.createElement(
              'div',
              { className: _Users2.default.newUserHeader },
              _react2.default.createElement(
                'div',
                { className: classesTheme },
                this.renderNav()
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderNav',
    value: function renderNav() {

      if (this.isSelecting()) {
        var countMessage = this.props.selected.length === 1 ? (0, _translations2.default)('CONTACT SELECTED') : (0, _translations2.default)('CONTACTS SELECTED');

        return _react2.default.createElement(
          _components.ContextNav,
          {
            key: 'ContextNav',
            selectedElementsCount: this.props.selected.length + '  ' + countMessage,
            unselect: this.props.usersUnselectAll,
            className: _Users2.default.navarCrud
          },
          this.props.selected.length > 1 ? null : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _Allow2.default,
              { permissions: ['account:user:edit:info'] },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: 'action left',
                  onClick: this.editUser },
                (0, _translations2.default)('EDIT USER'),
                _react2.default.createElement(md.edit, { size: 20 })
              )
            )
          ),
          _react2.default.createElement(
            _Allow2.default,
            { permissions: ['account:user:delete'] },
            _react2.default.createElement(
              _reactRouter.Link,
              { className: 'action right', onClick: this.deleteSelected },
              (0, _translations2.default)('DELETE'),
              _react2.default.createElement(md.delete, { size: 20 })
            )
          )
        );
      }

      return _react2.default.createElement(
        _components.Nav,
        { className: 'action right ' + _Users2.default.border, key: 'Nav' },
        _react2.default.createElement(
          _reactRouter.Link,
          { className: _Users2.default.newUser, to: {
              pathname: '/user/new/',
              state: {
                returnTo: '/users/'
              }
            }, style: { marginLeft: 'auto' } },
          (0, _translations2.default)('NEW USER'),
          _react2.default.createElement(md.personAdd, { size: 20 })
        )
      );
    }
  }, {
    key: 'renderTabs',
    value: function renderTabs() {
      return _react2.default.createElement(_components.Tabs, { simple: true,
        options: [{
          href: '/users/',
          title: (0, _translations2.default)('USERS'),
          is_index: true
        }] });
    }
  }, {
    key: 'renderInfiniteList',
    value: function renderInfiniteList() {
      var _this3 = this;

      if (__SERVER__) {
        return _react2.default.createElement(_components.VirtualListItemLoad, null);
      }
      var users_list = this.props.list;
      var hidden = { display: 'none' };
      var visible = { display: 'block' };
      var infiniteStyle = this.props.isLoading || users_list.length > 0 ? visible : hidden;
      return _react2.default.createElement(
        'div',
        { style: infiniteStyle },
        users_list.map(function (item, index) {
          return _react2.default.createElement(_components.VirtualListItemUser, {
            key: index,
            name: item.first_name + ' ' + item.last_name,
            email: _react2.default.createElement(
              'div',
              null,
              ' ',
              item.email,
              ' ',
              item.federated_user && _react2.default.createElement(
                'span',
                { className: _Users2.default.badgeDark },
                'SSO'
              ),
              ' '
            ),
            roles: item.roles,
            status: item.status,
            index: index,
            icon: _react2.default.createElement(md.person, { size: 40 }),
            active: item.active || false,
            setActive: _this3.setActive,
            selecting: _this3.isSelecting(),
            destination: [0]
          });
        })
      );
    }
  }]);
  return UsersList;
}(_components.List), _class3.propTypes = {
  pushState: _propTypes2.default.func.isRequired
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'deleteSelected', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'deleteSelected'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'editUser', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'editUser'), _class2.prototype)), _class2)) || _class) || _class);
//#endregion

//#region NEW USER ON SUBACCOUNT

var NewSubAccountUser = exports.NewSubAccountUser = (_dec3 = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    var state = getState();
    return dispatch((0, _status.getAccountStatus)());
  }
}]), _dec4 = (0, _reactRedux.connect)(function (state) {
  return { isLoading: state.status.loading, account: state.status.data, account_info: state.account, auth: state.auth, list: state.subaccounts.list };
}, { getAccountStatus: _status.getAccountStatus, createUser: _users.createUser, pushState: _reachHistory.push, getSubaccounts: _subaccounts.getSubaccounts, refreshSubaccounts: _subaccounts.refreshSubaccounts, createChildAccountUsers: _subaccountUsers.createChildAccountUsers, getSubAccountRoles: _roles.getSubAccountRoles, getAccount: _account2.getAccount }), _dec3(_class4 = _dec4(_class4 = (_class5 = (_temp2 = _class6 = function (_React$Component) {
  (0, _inherits3.default)(NewSubAccountUser, _React$Component);

  function NewSubAccountUser(props) {
    (0, _classCallCheck3.default)(this, NewSubAccountUser);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (NewSubAccountUser.__proto__ || (0, _getPrototypeOf2.default)(NewSubAccountUser)).call(this, props));

    _this4.handleSubAccountChange = function (selectedOption) {

      _this4.setState({
        subAccount: selectedOption.value,
        subAccountName: selectedOption.label
      });
    };

    _this4.handleRoleId = function (value) {
      var final = [];
      var name = [];
      value.map(function (item) {
        var value = item.value;
        var permission_name = item.label;
        final.push(value);
        name.push(permission_name);
      });
      _this4.setState({
        role_id: final,
        rolesName: name
      });
    };

    _this4.handleMsisdnChange = function (value) {
      _this4.setState({ msisdn: value });
    };

    _this4.account_uid = props.auth.data.account_list.find(function (a) {
      return a.is_active;
    }).account_uid;
    _this4.isStaff = props.auth.current_account.roles.indexOf('staff') > -1;

    _this4.state = (0, _extends3.default)({}, _this4.state, {
      usertags: [],
      userrole: 'admin',
      userSubAccount: [],
      subAccountRoles: [],
      role_id: [null],
      subAccount: null,
      account_roles: [],
      rolesName: null,
      subAccountName: [],
      table: [],
      subAccounts: [],
      selectedSubAccounts: [],
      snackMessage: "",
      snackStatus: "succeed",
      showSnack: false,
      begin_hour: 8,
      end_hour: 17,
      federated_user: "",
      msisdn: ""
    });
    _this4.props.refreshSubaccounts();
    _this4.props.getSubaccounts();
    _this4.saved = false;
    return _this4;
  }

  (0, _createClass3.default)(NewSubAccountUser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this5 = this;

      setTimeout(function () {
        _this5.props.getAccountStatus();
        _this5.props.getAccount();
      }, 0);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave() {
      var formChange = false;

      for (var x in this.refs) {
        if (this.refs[x].value != "") formChange = true;
      }if (this.state.account_roles.length > 0) formChange = true;

      if (this.state.msisdn !== "") formChange = true;

      if (formChange && !this.saved) return confirm((0, _translations2.default)("LEAVE WITHOUT SAVING"));

      return true;
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var roles;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.getSubAccounts();
                _context.next = 3;
                return this.props.getSubAccountRoles();

              case 3:
                roles = _context.sent;

                this.setState({ subAccountRoles: roles });

                this.unregisterRouteHook = this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'getSubAccountRoles',
    value: function getSubAccountRoles(list) {
      var options = [];
      list.map(function (item) {
        var value = item._id;
        var label = item.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'handleRoleChange',
    value: function handleRoleChange(e) {
      this.setState((0, _extends3.default)({}, this.state, {
        userrole: e.target.value
      }));
    }
  }, {
    key: 'addAccount',
    value: function addAccount() {
      if (this.state.subAccount != null && this.state.rolesName != null) {
        var selectedSubAccount = {
          value: this.state.subAccount,
          label: this.state.subAccountName

        };
        this.removingSelectedSubAccount(this.state.subAccountName);
        this.state.selectedSubAccounts.push(selectedSubAccount);
        var account_uid = this.state.subAccount;
        var roles_id = this.state.role_id;
        var selectedAccount = { account_uid: account_uid, permissions: { roles: roles_id } };
        var loRole = this.state.account_roles.concat(selectedAccount);
        var table = { account: this.state.subAccountName, permissions: this.state.rolesName };
        var tableData = this.state.table.concat(table);
        this.setState({ account_roles: loRole });
        this.setState({ table: tableData });
        this.setState({ role_id: null });
        this.setState({ subAccount: null });
        this.setState({ rolesName: null });
      } else {
        console.log('faltan datos');
      }
    }
  }, {
    key: 'removingSelectedSubAccount',
    value: function removingSelectedSubAccount(label) {
      var subaccounts_list = this.state.subAccounts;
      var index = subaccounts_list.findIndex(function (item) {
        return item.label == label;
      });
      subaccounts_list.splice(index, 1);
    }
  }, {
    key: 'handleUserSubmit',
    value: function handleUserSubmit() {
      var _this6 = this;

      var userdata = {
        first_name: this.refs.first_name.value,
        last_name: this.refs.last_name.value,
        username: this.refs.email.value,
        email: this.refs.email.value,
        msisdn: this.state.msisdn && this.state.msisdn.length === 3 ? "" : this.state.msisdn,
        federated_user: !!this.state.federated_user,
        roles: [],
        tags: this.state.usertags,
        agent: {
          available: true,
          begin_hour: this.state.begin_hour,
          end_hour: this.state.end_hour,
          department: this.refs.department.value,
          tags: []
        }
      };
      if (this.state.federated_user == null && (0, _featureEnabled.featureEnabled)('application_sso')) {
        this.showSnackBar("Debe indicar si el usuario es federado", "warning");
        return;
      }
      var account_uid = this.account_uid;
      this.props.createChildAccountUsers(userdata, this.state.account_roles).then(function () {
        _this6.saved = true;
        _this6.props.pushState({
          pathname: '/success',
          state: {
            goTo: '/reseller/users/',
            message: (0, _translations2.default)('USER CREATION REQUESTED'),
            modal: true,
            returnTo: '/reseller/users/'
          }
        });
      }).catch(function (e) {
        console.error('error', e);
      });
    }
  }, {
    key: 'getSubAccountOptions',
    value: function getSubAccountOptions(list) {
      var options = [];
      list.map(function (item) {
        var value = item.reach._id;
        var label = '' + item.reach.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'deleteTableValue',
    value: function deleteTableValue(index, account) {
      var subaccounts_list = this.state.subAccounts;
      var selected_subaccounts = this.state.selectedSubAccounts;
      var pushAccounts = selected_subaccounts.find(function (item) {
        return item.label == account;
      });
      var tableData = this.state.table;
      var accountData = this.state.account_roles;
      tableData.splice(index, 1);
      accountData.splice(index, 1);
      subaccounts_list.push(pushAccounts);
      this.setState({ table: tableData });
      this.setState({ account_roles: accountData });
    }
  }, {
    key: 'renderTableData',
    value: function renderTableData() {
      var _this7 = this;

      return this.state.table.map(function (accounts, index) {
        var id = accounts.id,
            account = accounts.account,
            permissions = accounts.permissions;

        if (_this7.state.table != [null]) {
          return _react2.default.createElement(
            'tr',
            { key: id, className: _Users2.default.trTable },
            _react2.default.createElement(
              'td',
              { style: { width: '30%' } },
              account
            ),
            _react2.default.createElement(
              'td',
              { style: { width: '60%' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'grid',
                    'grid-template-columns': 'auto auto auto auto',
                    'gap': '5px 10px' } },
                permissions.map(function (permission) {
                  return _react2.default.createElement(
                    'div',
                    { style: { margin: 'auto', textAlign: 'center' } },
                    permission
                  );
                })
              )
            ),
            _react2.default.createElement(
              'td',
              { style: { textAlign: 'center' } },
              _react2.default.createElement(md.delete, { size: 15, onClick: function onClick() {
                  return _this7.deleteTableValue(index, account);
                } })
            )
          );
        } else {
          return null;
        }
      });
    }
  }, {
    key: 'getSubAccounts',
    value: function getSubAccounts() {
      var SubAccountOptions = this.getSubAccountOptions(this.props.list);
      this.setState({ subAccounts: SubAccountOptions });
    }
  }, {
    key: 'showSnackBar',
    value: function showSnackBar(message, status) {
      this.setState({
        snackMessage: message,
        snackStatus: status,
        showSnack: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      if (__SERVER__) {
        return _react2.default.createElement(_components.Loading, null);
      }

      var SubAccountOptions = this.getSubAccountOptions(this.props.list);
      var role = this.getSubAccountRoles(this.state.subAccountRoles);
      var subAccount = this.state.subAccount;

      var styles = require('./User.scss');
      var account = this.props.account;

      var hours = [].concat((0, _toConsumableArray3.default)(Array(24).keys())).map(function (hour) {
        return { value: hour, label: hour };
      });
      var federatedOption = [{ value: true, label: "Sí" }, { value: false, label: "No" }];
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(styles);

      if (!account || !account.account_name) {
        return _react2.default.createElement(
          'div',
          { className: styles.loading },
          _react2.default.createElement(_components.Loading, null)
        );
      }
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: styles.userMain },
          _react2.default.createElement(_Snackbar2.default, {
            messageText: this.state.snackMessage,
            variant: this.state.snackStatus,
            isOpen: this.state.showSnack,
            autoHideDuration: 2600,
            handleClose: function handleClose() {
              return _this8.setState({ showSnack: false });
            }
          }),
          _react2.default.createElement(
            'div',
            { className: styles.bar },
            _react2.default.createElement(
              'div',
              { className: styles.icon, onClick: this.props.router.goBack },
              _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.main },
            _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)("NEW USER") }),
            _react2.default.createElement(
              'div',
              { className: styles.wrapperNewUser },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'h2',
                  { className: styles.title },
                  'Datos del usuario'
                ),
                this.state.userrole === 'staff' && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: styles.label },
                    (0, _translations2.default)('USER TAGS')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.td2 },
                    _react2.default.createElement(_components.TagsSelect, {
                      onChange: this.handleTagsChange,
                      creatable: false
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER FIRST NAME')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'first_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER LAST NAME')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'last_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER EMAIL')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'email' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER PHONE')
                  ),
                  _react2.default.createElement(_StyledPhoneInput2.default, {
                    key: this.props.account_info.data.available_countries,
                    countries: this.props.account_info.data.available_countries,
                    value: this.state.msisdn,
                    onChange: this.handleMsisdnChange,
                    placeholder: (0, _translations2.default)('MSISDN PLACEHOLDER'),
                    inputClass: styles.input
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('DEPARTMENT')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'department' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.selectContainer },
                  _react2.default.createElement(
                    'div',
                    { className: styles.select },
                    _react2.default.createElement(
                      'label',
                      { className: styles.label },
                      (0, _translations2.default)('START HOUR')
                    ),
                    _react2.default.createElement(_reactSelect2.default, {
                      value: this.state.begin_hour,
                      placeholder: (0, _translations2.default)('START HOUR'),
                      options: hours,
                      onChange: function onChange(begin_hour) {
                        return _this8.setState({ begin_hour: begin_hour.value });
                      }
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.betweenHours },
                    ' '
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.select },
                    _react2.default.createElement(
                      'label',
                      { className: styles.label },
                      (0, _translations2.default)('END HOUR')
                    ),
                    _react2.default.createElement(_reactSelect2.default, {
                      value: this.state.end_hour,
                      placeholder: (0, _translations2.default)('END HOUR'),
                      options: hours,
                      onChange: function onChange(end_hour) {
                        return _this8.setState({ end_hour: end_hour.value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _Allow2.default,
                  { features: ['application_sso'] },
                  _react2.default.createElement(
                    'div',
                    { className: styles.container },
                    _react2.default.createElement(
                      'div',
                      { className: styles.select },
                      _react2.default.createElement(
                        'label',
                        { className: styles.label },
                        'Usuario federado'
                      ),
                      _react2.default.createElement(_reactSelect2.default, {
                        value: this.state.federated_user,
                        placeholder: 'Seleccione una opción',
                        options: federatedOption,
                        onChange: function onChange(federated_user) {
                          return _this8.setState({ federated_user: federated_user ? federated_user.value : null });
                        }
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.accountContainer },
                  _react2.default.createElement(
                    'h2',
                    { className: styles.title },
                    'Administraci\xF3n de permisos'
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.select },
                    _react2.default.createElement(_reactSelect2.default, {
                      placeholder: (0, _translations2.default)("SELECT ACCOUNT"),
                      options: this.state.subAccounts,
                      value: subAccount,
                      onChange: this.handleSubAccountChange
                    }),
                    _react2.default.createElement(_reactSelect2.default, {
                      multi: true,
                      value: this.state.role_id,
                      placeholder: (0, _translations2.default)('SELECT ROLES'),
                      options: role,
                      onChange: this.handleRoleId
                    }),
                    _react2.default.createElement(
                      'button',
                      { onClick: function onClick() {
                          return _this8.addAccount();
                        },
                        className: styles.Addbutton },
                      '+'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.table },
                    _react2.default.createElement(
                      'table',
                      { className: styles.tab },
                      _react2.default.createElement(
                        'tbody',
                        { className: styles.TBody },
                        this.renderTableData()
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { onClick: function onClick() {
                      return _this8.state.account_roles.length > 0 ? _this8.handleUserSubmit() : _this8.showSnackBar((0, _translations2.default)("ASSIGN SUBACCOUT FOR USER"), "warning");
                    }, className: styles.button },
                  (0, _translations2.default)('ADD NEW USER')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return NewSubAccountUser;
}(_react2.default.Component), _class6.defaultProps = {
  multi: true
}, _class6.propTypes = {
  getSubaccounts: _propTypes2.default.func.isRequired,
  list: _propTypes2.default.array.isRequired,
  account: _propTypes2.default.object.isRequired,
  multi: _propTypes2.default.bool
}, _temp2), (_applyDecoratedDescriptor(_class5.prototype, 'routerWillLeave', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'routerWillLeave'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'handleRoleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'handleRoleChange'), _class5.prototype), _applyDecoratedDescriptor(_class5.prototype, 'handleUserSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class5.prototype, 'handleUserSubmit'), _class5.prototype)), _class5)) || _class4) || _class4);
//#endregion

//#region NEW USER

var NewUser = exports.NewUser = (_dec5 = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref4) {
    var _ref4$store = _ref4.store,
        dispatch = _ref4$store.dispatch,
        getState = _ref4$store.getState;

    var state = getState();
    return dispatch((0, _status.getAccountStatus)());
  }
}, {
  key: 'auth',
  promise: function promise(_ref5) {
    var _ref5$store = _ref5.store,
        dispatch = _ref5$store.dispatch,
        getState = _ref5$store.getState;

    if (!(0, _auth.isLoaded)(getState())) {
      return dispatch((0, _auth.load)());
    }
  }
}]), _dec6 = (0, _reactRedux.connect)(function (state) {
  return { isLoading: state.status.loading, account: state.status.data, account_info: state.account, auth: state.auth };
}, { getAccountStatus: _status.getAccountStatus, createUser: _users.createUser, pushState: _reachHistory.push, getAccountRoles: _roles.getAccountRoles, getAccount: _account2.getAccount }), _dec5(_class7 = _dec6(_class7 = (_class8 = (_temp3 = _class9 = function (_React$Component2) {
  (0, _inherits3.default)(NewUser, _React$Component2);

  function NewUser(props) {
    (0, _classCallCheck3.default)(this, NewUser);

    var _this9 = (0, _possibleConstructorReturn3.default)(this, (NewUser.__proto__ || (0, _getPrototypeOf2.default)(NewUser)).call(this, props));

    _this9.handleRoleId = function (value) {
      var final = [];
      value.map(function (item) {
        var value = item.value;
        final.push(value);
      });
      _this9.setState({
        role_id: final
      });
    };

    _this9.handleMsisdnChange = function (value) {
      _this9.setState({ msisdn: value });
    };

    _this9.account_uid = props.auth.data.account_list.find(function (a) {
      return a.is_active;
    }).account_uid;
    _this9.isStaff = props.auth.current_account.roles.indexOf('staff') > -1;

    _this9.state = (0, _extends3.default)({}, _this9.state, {
      usertags: [],
      msisdn: "",
      userrole: 'admin',
      roles: [],
      role_id: [],
      begin_hour: 8,
      end_hour: 17
    });
    _this9.saved = false;
    return _this9;
  }

  (0, _createClass3.default)(NewUser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this10 = this;

      setTimeout(function () {
        _this10.props.getAccountStatus();
        _this10.props.getAccount();
      }, 0);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave() {
      var formChange = false;

      for (var x in this.refs) {
        if (this.refs[x].value != "") formChange = true;
      }if (this.state.role_id.length > 0) formChange = true;

      if (this.state.msisdn !== "") formChange = true;

      if (formChange && !this.saved) return confirm((0, _translations2.default)("LEAVE WITHOUT SAVING"));

      return true;
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
        var roles, CSMS_ONLY_ROLES;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.unregisterRouteHook = this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);
                _context2.next = 3;
                return this.props.getAccountRoles(this.account_uid);

              case 3:
                roles = _context2.sent;

                // check if role name doesnt start with reach
                CSMS_ONLY_ROLES = roles.filter(function (role) {
                  return role.name.indexOf('reach') === -1;
                });

                this.setState({ roles: CSMS_ONLY_ROLES });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _ref6.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'getAccountRoles',
    value: function getAccountRoles(list) {
      var options = [];
      list.map(function (item) {
        var value = item._id;
        var label = item.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'handleRoleChange',
    value: function handleRoleChange(e) {
      this.setState((0, _extends3.default)({}, this.state, {
        userrole: e.target.value
      }));
    }
  }, {
    key: 'showSnackBar',
    value: function showSnackBar(message, status) {
      this.setState({
        snackMessage: message,
        snackStatus: status,
        showSnack: true
      });
    }
  }, {
    key: 'handleUserSubmit',
    value: function handleUserSubmit() {
      var _this11 = this;

      var userdata = {
        first_name: this.refs.first_name.value,
        last_name: this.refs.last_name.value,
        username: this.refs.email.value,
        email: this.refs.email.value,
        msisdn: this.state.msisdn && this.state.msisdn.length === 3 ? "" : this.state.msisdn,
        federated_user: !!this.state.federated_user,
        roles: [],
        tags: this.state.usertags,
        agent: {
          available: true,
          begin_hour: this.state.begin_hour,
          end_hour: this.state.end_hour,
          department: this.refs.department.value,
          tags: []
        }
      };
      var fieldTranslations = {
        first_name: 'Nombre',
        last_name: 'Apellido',
        email: 'Email',
        msisdn: 'Número de teléfono',
        roles: 'Roles',
        department: 'Departamento',
        federated_user: "Usuario federado"
      };
      var isEmpty = false;
      var keys = (0, _keys2.default)(userdata);
      for (var i = keys.length - 1; i >= 0; i--) {
        var key = keys[i];

        if (key === 'username' || key === 'msisdn' || key === 'department' || key === 'tags') {
          continue;
        }
        if (!userdata[key]) {
          if (key === 'federated_user' && !(0, _featureEnabled.featureEnabled)('application_sso')) {
            continue;
          } else if (key === 'federated_user' && (0, _featureEnabled.featureEnabled)('application_sso') && userdata[key] === false) {
            continue;
          }
          var fieldName = fieldTranslations[key] || key;
          this.showSnackBar('El campo "' + fieldName + '" se encuentra vac\xEDo', "warning");
          isEmpty = true;
        }
      }

      var account_uid = this.account_uid;
      var permissions = { roles: this.state.role_id };
      if (permissions.roles.length === 0) {
        this.showSnackBar('El campo "Roles" se encuentra vacío', "warning");
        isEmpty = true;
      }
      if (!isEmpty) {
        this.props.createUser(userdata, account_uid, permissions).then(function () {
          _this11.saved = true;
          _this11.props.pushState({
            pathname: '/success',
            state: {
              goTo: '/users/',
              message: (0, _translations2.default)('USER CREATION REQUESTED'),
              modal: true,
              returnTo: '/users/'
            }
          });
        }).catch(function (e) {
          console.error('error', e);
        });
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this12 = this;

      var federatedOption = [{ value: true, label: "Sí" }, { value: false, label: "No" }];
      if (__SERVER__) {
        return _react2.default.createElement(_components.Loading, null);
      }

      var styles = require('./User.scss');
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(styles);
      var account = this.props.account;


      var role = this.getAccountRoles(this.state.roles);
      var hours = [].concat((0, _toConsumableArray3.default)(Array(24).keys())).map(function (hour) {
        return { value: hour, label: hour };
      });

      if (!account || !account.account_name) {
        return _react2.default.createElement(
          'div',
          { className: styles.loading },
          _react2.default.createElement(_components.Loading, null)
        );
      }
      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: styles.userMain },
          _react2.default.createElement(_Snackbar2.default, {
            messageText: this.state.snackMessage,
            variant: this.state.snackStatus,
            isOpen: this.state.showSnack,
            autoHideDuration: 2600,
            handleClose: function handleClose() {
              return _this12.setState({ showSnack: false });
            }
          }),
          _react2.default.createElement(
            'div',
            { className: styles.bar },
            _react2.default.createElement(
              'div',
              { className: styles.icon, onClick: this.props.router.goBack },
              _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.main },
            _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)("NEW USER") }),
            _react2.default.createElement(
              'div',
              { className: styles.wrapper },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER FIRST NAME')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'first_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER LAST NAME')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'last_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER EMAIL')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'email' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER PHONE')
                  ),
                  _react2.default.createElement(_StyledPhoneInput2.default, {
                    key: this.props.account_info.data.available_countries,
                    countries: this.props.account_info.data.available_countries,
                    value: this.state.msisdn,
                    onChange: this.handleMsisdnChange,
                    placeholder: (0, _translations2.default)('MSISDN PLACEHOLDER'),
                    inputClass: styles.input
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('ROLES')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    multi: true,
                    value: this.state.role_id,
                    placeholder: (0, _translations2.default)('SELECT'),
                    options: role,
                    onChange: this.handleRoleId
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('DEPARTMENT')
                  ),
                  _react2.default.createElement('input', { className: styles.input, ref: 'department' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.selectContainer },
                  _react2.default.createElement(
                    'div',
                    { className: styles.select },
                    _react2.default.createElement(
                      'label',
                      { className: styles.label },
                      (0, _translations2.default)('START HOUR')
                    ),
                    _react2.default.createElement(_reactSelect2.default, {
                      value: this.state.begin_hour,
                      placeholder: (0, _translations2.default)('START HOUR'),
                      options: hours,
                      onChange: function onChange(begin_hour) {
                        return _this12.setState({ begin_hour: begin_hour.value });
                      }
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.betweenHours },
                    ' '
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.select },
                    _react2.default.createElement(
                      'label',
                      { className: styles.label },
                      (0, _translations2.default)('END HOUR')
                    ),
                    _react2.default.createElement(_reactSelect2.default, {
                      value: this.state.end_hour,
                      placeholder: (0, _translations2.default)('END HOUR'),
                      options: hours,
                      onChange: function onChange(end_hour) {
                        return _this12.setState({ end_hour: end_hour.value });
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _Allow2.default,
                  { features: ['application_sso'] },
                  _react2.default.createElement(
                    'div',
                    { className: styles.container },
                    _react2.default.createElement(
                      'div',
                      { className: styles.select },
                      _react2.default.createElement(
                        'label',
                        { className: styles.label },
                        'Usuario federado'
                      ),
                      _react2.default.createElement(_reactSelect2.default, {
                        value: this.state.federated_user,
                        placeholder: 'Seleccione una opción',
                        options: federatedOption,
                        onChange: function onChange(federated_user) {
                          return _this12.setState({ federated_user: federated_user ? federated_user.value : null });
                        }
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { onClick: this.handleUserSubmit, className: styles.button },
                  (0, _translations2.default)('ADD NEW USER')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/users.svg'), className: styles.artwork })
            )
          )
        )
      );
    }
  }]);
  return NewUser;
}(_react2.default.Component), _class9.propTypes = {
  account: _propTypes2.default.object.isRequired
}, _temp3), (_applyDecoratedDescriptor(_class8.prototype, 'routerWillLeave', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, 'routerWillLeave'), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, 'handleRoleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, 'handleRoleChange'), _class8.prototype), _applyDecoratedDescriptor(_class8.prototype, 'handleUserSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class8.prototype, 'handleUserSubmit'), _class8.prototype)), _class8)) || _class7) || _class7);

//#endregion

//#region EDIT USER ON SUBACCOUNT

var EditUserSubaccount = exports.EditUserSubaccount = (_dec7 = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref7) {
    var _ref7$store = _ref7.store,
        dispatch = _ref7$store.dispatch,
        getState = _ref7$store.getState;

    var state = getState();
    return dispatch((0, _status.getAccountStatus)());
  }
}]), _dec8 = (0, _reactRedux.connect)(function (state) {
  return { isLoading: state.status.loading, account: state.status.data, account_info: state.account,
    auth: state.auth, list: state.subaccounts.list, permissions_list: state.subAccountUsers.list };
}, { getAccountStatus: _status.getAccountStatus, updateChildAccountUsers: _subaccountUsers.updateChildAccountUsers, getSubaccounts: _subaccounts.getSubaccounts, refreshSubaccounts: _subaccounts.refreshSubaccounts, pushState: _reachHistory.push, deleteChildAccountUsers: _subaccountUsers.deleteChildAccountUsers, createChildAccountUsers: _subaccountUsers.createChildAccountUsers, getSubAccountRoles: _roles.getSubAccountRoles, getAccount: _account2.getAccount, activateUser: _users.activateUser }), _dec7(_class10 = _dec8(_class10 = (_class11 = (_temp4 = _class12 = function (_React$Component3) {
  (0, _inherits3.default)(EditUserSubaccount, _React$Component3);

  function EditUserSubaccount(props) {
    var _this13$state;

    (0, _classCallCheck3.default)(this, EditUserSubaccount);

    var _this13 = (0, _possibleConstructorReturn3.default)(this, (EditUserSubaccount.__proto__ || (0, _getPrototypeOf2.default)(EditUserSubaccount)).call(this, props));

    _this13.handleSubAccountChange = function (selectedOption) {
      _this13.setState({
        subAccount: selectedOption.value,
        subAccountName: selectedOption.label
      });
    };

    _this13.handleRoleId = function (value) {
      var final = [];
      var name = [];
      value.map(function (item) {
        var value = item.value;
        var permission_name = item.label;
        final.push(value);
        name.push(permission_name);
      });
      _this13.setState({
        role_id: final,
        rolesName: name
      });
    };

    _this13.handleMsisdnChange = function (value) {
      _this13.setState({ msisdn: value });
    };

    _this13.handleActivateUser = function () {
      _this13.props.activateUser(_this13.state.user._id).then(function () {
        _this13.props.pushState({
          pathname: '/success',
          state: { goTo: '/reseller/users/', message: (0, _translations2.default)('USER ACTIVATED'), modal: true, returnTo: '/reseller/users/' }
        });
      });
    };

    var user = _this13.props.location.state.subAccount;
    var accounts = [];
    user.subaccounts.map(function (item) {
      var value = item._id;
      var label = item.name;
      var values = { value: value, label: label };
      accounts.push(values);
    });
    var user_permissions = _this13.getUserPermissions(_this13.props.permissions_list, user._id);
    var initial_subaccount_roles = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(user_permissions.subaccounts), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var value = _step.value;

        initial_subaccount_roles[value._id] = value.roles_uid;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    _this13.state = (_this13$state = {
      requesting: false,
      usertags: user.tags,
      user: user
    }, (0, _defineProperty3.default)(_this13$state, 'usertags', user.tags), (0, _defineProperty3.default)(_this13$state, 'msisdn', user.msisdn), (0, _defineProperty3.default)(_this13$state, 'currentAccounts', user.subaccounts.map(function (value) {
      return value._id;
    })), (0, _defineProperty3.default)(_this13$state, 'defaultValue', accounts), (0, _defineProperty3.default)(_this13$state, 'newAccounts', accounts), (0, _defineProperty3.default)(_this13$state, 'finalSubaccounts', user.subaccounts.map(function (value) {
      return value._id;
    })), (0, _defineProperty3.default)(_this13$state, 'userSubAccount', []), (0, _defineProperty3.default)(_this13$state, 'subAccountRoles', []), (0, _defineProperty3.default)(_this13$state, 'role_id', [null]), (0, _defineProperty3.default)(_this13$state, 'subAccount', null), (0, _defineProperty3.default)(_this13$state, 'account_roles', user_permissions.subaccounts.map(function (value) {
      return { account_uid: value._id, permissions: { roles: value.roles_uid } };
    })), (0, _defineProperty3.default)(_this13$state, 'rolesName', null), (0, _defineProperty3.default)(_this13$state, 'subAccountName', []), (0, _defineProperty3.default)(_this13$state, 'user_permissions', user_permissions), (0, _defineProperty3.default)(_this13$state, 'initial_subaccount_roles', initial_subaccount_roles), (0, _defineProperty3.default)(_this13$state, 'table', user_permissions.subaccounts.map(function (value) {
      return {
        id: value._id,
        account: value.name,
        permissions: value.roles
      };
    })), (0, _defineProperty3.default)(_this13$state, 'subAccounts', []), (0, _defineProperty3.default)(_this13$state, 'selectedSubAccounts', []), (0, _defineProperty3.default)(_this13$state, 'snackMessage', ""), (0, _defineProperty3.default)(_this13$state, 'snackStatus', "succeed"), (0, _defineProperty3.default)(_this13$state, 'showSnack', false), (0, _defineProperty3.default)(_this13$state, 'begin_hour', user.agent ? user.agent.begin_hour : 8), (0, _defineProperty3.default)(_this13$state, 'end_hour', user.agent ? user.agent.end_hour : 17), _this13$state);
    _this13.props.refreshSubaccounts();
    _this13.props.getSubaccounts();
    _this13.account_uid = props.auth.data.account_list.find(function (a) {
      return a.is_active;
    }).account_uid;
    _this13.isStaff = props.auth.current_account.roles.indexOf('staff') > -1;
    _this13.saved = false;
    return _this13;
  }

  (0, _createClass3.default)(EditUserSubaccount, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this14 = this;

      setTimeout(function () {
        _this14.props.getAccountStatus();
        _this14.props.getAccount();
      }, 0);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave() {
      var formChange = false;

      for (var x in this.refs) {
        if (this.refs[x].value != this.initialUser[x] && this.refs[x].value != this.initialAgent[x]) formChange = true;
      }if ((0, _stringify2.default)(this.state.account_roles) != this.initialRoles) formChange = true;

      if (this.state.msisdn !== this.state.user.msisdn) formChange = true;

      if (formChange && !this.saved) return confirm((0, _translations2.default)("LEAVE WITHOUT SAVING"));

      return true;
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3() {
        var roles;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.getSubAccounts();
                _context3.next = 3;
                return this.props.getSubAccountRoles();

              case 3:
                roles = _context3.sent;

                this.setState({ subAccountRoles: roles });
                this.removeCurrentAccounts();

                this.initialUser = (0, _assign2.default)({}, this.state.user);
                this.initialAgent = this.initialUser.agent || {
                  beigin_hour: 8,
                  end_hour: 17,
                  department: ""
                };
                this.initialRoles = (0, _stringify2.default)(this.state.account_roles);
                this.unregisterRouteHook = this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _ref8.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'getUserPermissions',
    value: function getUserPermissions(permissions_list, user_uid) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = (0, _getIterator3.default)(permissions_list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var permissions = _step2.value;

          if (permissions._id == user_uid) return permissions;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }, {
    key: 'getSubAccountRoles',
    value: function getSubAccountRoles(list) {
      var options = [];
      list.map(function (item) {
        var value = item._id;
        var label = item.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'removeCurrentAccounts',
    value: function removeCurrentAccounts() {
      var subaccounts_list = this.state.subAccounts;
      var currentAccounts = this.state.currentAccounts;
      var defaultSubAccount = this.state.defaultValue;
      currentAccounts.forEach(function (value) {
        var index = subaccounts_list.findIndex(function (item) {
          return item.value == value;
        });
        subaccounts_list.splice(index, 1);
      });
      this.setState({ selectedSubAccounts: defaultSubAccount });
    }
  }, {
    key: 'addAccount',
    value: function addAccount() {
      if (this.state.subAccount != null && this.state.rolesName != null) {
        var selectedSubAccount = {
          value: this.state.subAccount,
          label: this.state.subAccountName

        };
        this.state.selectedSubAccounts.push(selectedSubAccount);
        this.removingSelectedSubAccount(this.state.subAccountName);
        var account_uid = this.state.subAccount;
        var roles_id = this.state.role_id;
        var selectedAccount = { account_uid: account_uid, permissions: { roles: roles_id } };
        var loRole = this.state.account_roles.concat(selectedAccount);
        var table = { account: this.state.subAccountName, permissions: this.state.rolesName };
        var tableData = this.state.table.concat(table);
        this.setState({ account_roles: loRole });
        this.setState({ table: tableData });
        this.setState({ role_id: null });
        this.setState({ subAccount: null });
        this.setState({ rolesName: null });
      }
    }
  }, {
    key: 'removingSelectedSubAccount',
    value: function removingSelectedSubAccount(label) {
      var subaccounts_list = this.state.subAccounts;
      var index = subaccounts_list.findIndex(function (item) {
        return item.label == label;
      });
      subaccounts_list.splice(index, 1);
    }
  }, {
    key: 'handleTagsChange',
    value: function handleTagsChange(tags) {
      this.setState((0, _extends3.default)({}, this.state, {
        usertags: tags.map(function (t) {
          return t.value;
        })
      }));
    }
  }, {
    key: 'getSubAccountOptions',
    value: function getSubAccountOptions(list) {
      var options = [];
      list.map(function (item) {
        var value = item.reach._id;
        var label = '' + item.reach.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'getSubAccountOptions',
    value: function getSubAccountOptions(list) {
      var options = [];
      list.map(function (item) {
        var value = item.reach._id;
        var label = '' + item.reach.name;
        var option = { value: value, label: label };
        options.push(option);
      });
      return options;
    }
  }, {
    key: 'deleteTableValue',
    value: function deleteTableValue(index, account) {
      var subaccounts_list = this.state.subAccounts;
      var selected_subaccounts = this.state.selectedSubAccounts;
      var pushAccounts = selected_subaccounts.find(function (item) {
        return item.label == account;
      });
      var tableData = this.state.table;
      var accountData = this.state.account_roles;
      tableData.splice(index, 1);
      accountData.splice(index, 1);
      subaccounts_list.push(pushAccounts);
      this.setState({ table: tableData });
      this.setState({ account_roles: accountData });
    }
  }, {
    key: 'renderTableData',
    value: function renderTableData() {
      var _this15 = this;

      return this.state.table.map(function (accounts, index) {
        var id = accounts.id,
            account = accounts.account,
            permissions = accounts.permissions;

        if (_this15.state.table != [null]) {
          return _react2.default.createElement(
            'tr',
            { key: id, className: _Users2.default.trTable },
            _react2.default.createElement(
              'td',
              { style: { width: '30%' } },
              account
            ),
            _react2.default.createElement(
              'td',
              { style: { width: '60%' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'grid',
                    'grid-template-columns': 'auto auto auto auto',
                    'gap': '5px 10px' } },
                permissions.map(function (permission) {
                  return _react2.default.createElement(
                    'div',
                    { style: { margin: 'auto', textAlign: 'center' } },
                    permission
                  );
                })
              )
            ),
            _react2.default.createElement(
              'td',
              { style: { textAlign: 'center' } },
              _react2.default.createElement(md.delete, { size: 15, onClick: function onClick() {
                  return _this15.deleteTableValue(index, account);
                } })
            )
          );
        } else {
          return null;
        }
      });
    }
  }, {
    key: 'getSubAccounts',
    value: function getSubAccounts() {
      var SubAccountOptions = this.getSubAccountOptions(this.props.list);
      this.setState({ subAccounts: SubAccountOptions });
    }
  }, {
    key: 'handleUserSubmit',
    value: function handleUserSubmit() {
      var _this16 = this;

      var userdata = {
        first_name: this.refs.first_name.value,
        last_name: this.refs.last_name.value,
        username: this.refs.email.value,
        email: this.refs.email.value,
        msisdn: this.state.msisdn && this.state.msisdn.length === 3 ? "" : this.state.msisdn,
        roles: [],
        tags: this.state.usertags,
        agent: {
          available: true,
          begin_hour: this.state.begin_hour,
          end_hour: this.state.end_hour,
          department: this.refs.department.value
        }
      };
      var account_uid = this.account_uid;
      var permissions = null;
      var user_uid = this.props.location.state.subAccount._id;
      var accounts_roles = this.state.account_roles;

      var final_subaccount_roles = {};
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = (0, _getIterator3.default)(accounts_roles), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var value = _step3.value;

          final_subaccount_roles[value.account_uid] = value.permissions.roles;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      var user_subaccounts_roles = this.handleSubAccounts(final_subaccount_roles, account_uid, user_uid);

      this.props.updateChildAccountUsers(user_uid, userdata, user_subaccounts_roles).then(function () {
        _this16.saved = true;
        _this16.props.pushState({
          pathname: '/success',
          state: { goTo: '/reseller/users/',
            message: (0, _translations2.default)('UPDATED USER'),
            modal: true,
            returnTo: '/reseller/users/'
          }
        });
      });
    }
  }, {
    key: 'handleSubAccounts',
    value: function handleSubAccounts(final_subaccount_roles, account_uid, user_uid) {
      var add_permissions = [];
      var update_permissions = [];
      var delete_permissions = [];
      var initial_subaccount_roles = this.state.initial_subaccount_roles;

      for (var account in initial_subaccount_roles) {
        var initial_role = initial_subaccount_roles[account];
        var final_role = final_subaccount_roles[account];
        if (final_role) {
          if (initial_role != final_role) update_permissions.push({ user_uid: user_uid, account_uid: account, roles: final_role });
        } else {
          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = (0, _getIterator3.default)(this.state.user_permissions.subaccounts), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var subaccount = _step4.value;

              if (subaccount._id == account) delete_permissions.push(subaccount.user_permissions_uid);
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4.return) {
                _iterator4.return();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        }
      }

      for (var _account in final_subaccount_roles) {
        if (!initial_subaccount_roles[_account]) add_permissions.push({ user_uid: user_uid, account_uid: _account, roles: final_subaccount_roles[_account] });
      }

      return { add_permissions: add_permissions, update_permissions: update_permissions, delete_permissions: delete_permissions };
    }
  }, {
    key: 'showSnackBar',
    value: function showSnackBar(message, status) {
      this.setState({
        snackMessage: message,
        snackStatus: status,
        showSnack: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this17 = this;

      if (__SERVER__) {
        return _react2.default.createElement(_components.VirtualListItemLoad, null);
      }

      var styles = require('./User.scss');
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(styles);
      var account = this.props.account;

      var hours = [].concat((0, _toConsumableArray3.default)(Array(24).keys())).map(function (hour) {
        return { value: hour, label: hour };
      });
      var isSuspended = this.state.user.user_status === 'SUSPENDED';

      if (!account || !account.account_name) {
        return _react2.default.createElement(
          'div',
          { className: styles.loading },
          _react2.default.createElement(_components.Loading, null)
        );
      }

      //const subAccountOptions = this.getSubAccountOptions(this.props.list)
      var SubAccountOptions = this.getSubAccountOptions(this.props.list);
      var role = this.getSubAccountRoles(this.state.subAccountRoles);
      var subAccount = this.state.subAccount;

      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: styles.userMain },
          _react2.default.createElement(_Snackbar2.default, {
            messageText: this.state.snackMessage,
            variant: this.state.snackStatus,
            isOpen: this.state.showSnack,
            autoHideDuration: 2600,
            handleClose: function handleClose() {
              return _this17.setState({ showSnack: false });
            }
          }),
          _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)('EDIT USER') }),
          _react2.default.createElement(
            'div',
            { className: styles.bar },
            _react2.default.createElement(
              'div',
              { className: styles.icon, onClick: this.props.router.goBack },
              _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF' })
            )
          ),
          this.state.user.federated_user && _react2.default.createElement(
            'div',
            { className: styles.alert, role: 'alert' },
            _react2.default.createElement(
              'div',
              { style: { display: "flex", justifyContent: "space-between", alignItems: "center" } },
              _react2.default.createElement(md.warning, { size: 20 }),
              _react2.default.createElement(
                'div',
                { style: { textAlign: "center", width: "95%" } },
                _react2.default.createElement(
                  'h4',
                  null,
                  'Usuario federado'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: "11px", marginTop: "-20px" } },
              _react2.default.createElement(
                'p',
                null,
                'Como usuario federado, el acceso a la plataforma est\xE1 vinculado a la autenticaci\xF3n proporcionada por la empresa o instituci\xF3n. Todo lo referente a la autenticaci\xF3n, creaci\xF3n y modificaci\xF3n de credenciales ser\xE1n manejadas por dicho sistema de autenticaci\xF3n.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.userEdit },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.columnTitle },
                'Datos del usuario'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.inputStyle },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('USER FIRST NAME')
                ),
                _react2.default.createElement('input', { defaultValue: this.state.user.first_name, className: styles.input, ref: 'first_name' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.inputStyle },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('USER LAST NAME')
                ),
                _react2.default.createElement('input', { defaultValue: this.state.user.last_name, className: styles.input, ref: 'last_name' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.inputStyle },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('USER EMAIL')
                ),
                _react2.default.createElement('input', { defaultValue: this.state.user.email, className: styles.disabledInput, ref: 'email', disabled: true })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.inputStyle },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('USER PHONE')
                ),
                _react2.default.createElement(_StyledPhoneInput2.default, {
                  key: this.props.account_info.data.available_countries,
                  countries: this.props.account_info.data.available_countries,
                  value: this.state.msisdn,
                  onChange: this.handleMsisdnChange,
                  placeholder: (0, _translations2.default)('MSISDN PLACEHOLDER'),
                  inputClass: this.state.user.allow_sms_2fa ? styles.disabledInput : styles.input,
                  disabled: this.state.user.allow_sms_2fa
                })
              ),
              _react2.default.createElement('div', { className: styles.separateForm }),
              _react2.default.createElement(
                'div',
                { className: styles.container },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('DEPARTMENT')
                ),
                _react2.default.createElement('input', { className: styles.input, defaultValue: this.state.user.agent ? this.state.user.agent.department : "", ref: 'department' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.selectContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('START HOUR')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    value: this.state.begin_hour,
                    placeholder: (0, _translations2.default)('START HOUR'),
                    options: hours,
                    onChange: function onChange(begin_hour) {
                      return _this17.setState({ begin_hour: begin_hour.value });
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.betweenHours },
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('END HOUR')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    value: this.state.end_hour,
                    placeholder: (0, _translations2.default)('END HOUR'),
                    options: hours,
                    onChange: function onChange(end_hour) {
                      return _this17.setState({ end_hour: end_hour.value });
                    }
                  })
                )
              ),
              isSuspended && _react2.default.createElement(
                'span',
                { className: styles.suspendedLabel },
                (0, _translations2.default)('USER SUSPENDED')
              ),
              _react2.default.createElement('div', { className: styles.separateForm }),
              _react2.default.createElement(
                'div',
                { className: styles.logout },
                _react2.default.createElement(
                  'button',
                  { onClick: function onClick() {
                      return _this17.state.account_roles.length > 0 ? _this17.handleUserSubmit() : _this17.showSnackBar((0, _translations2.default)("ASSIGN SUBACCOUT FOR USER"), "warning");
                    }, className: (isSuspended && styles.disabledButton) + ' ' + styles.button, disabled: isSuspended },
                  (0, _translations2.default)('EDIT USER')
                ),
                isSuspended && _react2.default.createElement(
                  'button',
                  { onClick: this.handleActivateUser, className: styles.button + ' ' + styles.resellerActiveButton },
                  (0, _translations2.default)('ACTIVATE USER')
                )
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: styles.columnTitle },
                'Cuentas por agregar'
              ),
              _react2.default.createElement(
                'div',
                { className: styles.gridSelection },
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(_reactSelect2.default, {
                    placeholder: (0, _translations2.default)("SELECT ACCOUNT"),
                    options: this.state.subAccounts,
                    value: subAccount,
                    onChange: this.handleSubAccountChange
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'div',
                    { className: styles.tdSelect },
                    _react2.default.createElement(_reactSelect2.default, {
                      multi: true,
                      value: this.state.role_id,
                      placeholder: (0, _translations2.default)("SELECT ROLES"),
                      options: role,
                      onChange: this.handleRoleId
                    })
                  )
                ),
                _react2.default.createElement(
                  'button',
                  { onClick: function onClick() {
                      return _this17.addAccount();
                    },
                    className: styles.buttonAdd },
                  '+'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.tableEdit },
                _react2.default.createElement(
                  'table',
                  { className: styles.tab },
                  _react2.default.createElement(
                    'tbody',
                    { className: styles.TBody },
                    this.renderTableData()
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return EditUserSubaccount;
}(_react2.default.Component), _class12.propTypes = {
  getSubaccounts: _propTypes2.default.func.isRequired,
  list: _propTypes2.default.array.isRequired,
  account: _propTypes2.default.object.isRequired
}, _temp4), (_applyDecoratedDescriptor(_class11.prototype, 'routerWillLeave', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'routerWillLeave'), _class11.prototype), _applyDecoratedDescriptor(_class11.prototype, 'handleTagsChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'handleTagsChange'), _class11.prototype), _applyDecoratedDescriptor(_class11.prototype, 'handleUserSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'handleUserSubmit'), _class11.prototype), _applyDecoratedDescriptor(_class11.prototype, 'handleSubAccounts', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class11.prototype, 'handleSubAccounts'), _class11.prototype)), _class11)) || _class10) || _class10);

//#endregion

//#region EDIT USER

var EditUser = exports.EditUser = (_dec9 = (0, _reduxConnect.asyncConnect)([{
  key: 'account',
  promise: function promise(_ref9) {
    var _ref9$store = _ref9.store,
        dispatch = _ref9$store.dispatch,
        getState = _ref9$store.getState;

    var state = getState();
    return dispatch((0, _status.getAccountStatus)());
  }
}]), _dec10 = (0, _reactRedux.connect)(function (state) {
  return { isLoading: state.status.loading, account: state.status.data, account_info: state.account,
    auth: state.auth };
}, { getAccountStatus: _status.getAccountStatus, updateUser: _users.updateUser, pushState: _reachHistory.push, getAccountRoles: _roles.getAccountRoles, updateUserRoles: _users.updateUserRoles, getAccount: _account2.getAccount, activateUser: _users.activateUser }), _dec9(_class13 = _dec10(_class13 = (_class14 = (_temp5 = _class15 = function (_React$Component4) {
  (0, _inherits3.default)(EditUser, _React$Component4);

  function EditUser(props) {
    var _this18$state;

    (0, _classCallCheck3.default)(this, EditUser);

    var _this18 = (0, _possibleConstructorReturn3.default)(this, (EditUser.__proto__ || (0, _getPrototypeOf2.default)(EditUser)).call(this, props));

    _this18.handleMsisdnChange = function (value) {
      _this18.setState({ msisdn: value });
    };

    _this18.handleRoleId = function (value) {
      _this18.setState({ rolesEdited: true });
      var final = [];
      value.map(function (item) {
        var value = item.value;
        final.push(value);
      });
      _this18.setState({
        role_id: final
      });
    };

    _this18.handleActivateUser = function () {
      _this18.props.activateUser(_this18.state.user._id).then(function () {
        _this18.props.pushState({
          pathname: '/success',
          state: { goTo: '/users/', message: (0, _translations2.default)('USER ACTIVATED'), modal: true, returnTo: '/users/' }
        });
      });
    };

    var user = _this18.props.location.state.editUser;

    _this18.state = (_this18$state = {
      requesting: false,
      usertags: user.tags,
      userrole: user.roles[0],
      user: user
    }, (0, _defineProperty3.default)(_this18$state, 'usertags', user.tags), (0, _defineProperty3.default)(_this18$state, 'msisdn', user.msisdn), (0, _defineProperty3.default)(_this18$state, 'userRoles', _this18.props.location.state.editUser.roles_uid), (0, _defineProperty3.default)(_this18$state, 'roles', null), (0, _defineProperty3.default)(_this18$state, 'role_id', []), (0, _defineProperty3.default)(_this18$state, 'rolesEdited', false), (0, _defineProperty3.default)(_this18$state, 'begin_hour', user.agent ? user.agent.begin_hour : 8), (0, _defineProperty3.default)(_this18$state, 'end_hour', user.agent ? user.agent.end_hour : 17), _this18$state);

    _this18.account_uid = props.auth.data.account_list.find(function (a) {
      return a.is_active;
    }).account_uid;
    _this18.isStaff = props.auth.current_account.roles.indexOf('staff') > -1;
    _this18.saved = false;
    return _this18;
  }

  (0, _createClass3.default)(EditUser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this19 = this;

      setTimeout(function () {
        _this19.props.getAccountStatus();
        _this19.props.getAccount();
      }, 0);
    }
  }, {
    key: 'routerWillLeave',
    value: function routerWillLeave() {
      var formChange = false;

      for (var x in this.refs) {
        if (this.refs[x].value != this.initialUser[x] && this.refs[x].value != this.initialAgent[x]) formChange = true;
      }

      if ((0, _stringify2.default)(this.state.role_id) != this.initialRoles) formChange = true;

      if (this.state.msisdn !== this.state.user.msisdn) formChange = true;

      if (formChange && !this.saved) return confirm((0, _translations2.default)("LEAVE WITHOUT SAVING"));

      return true;
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4() {
        var roles, userRoles, options, selectedOptions;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.props.getAccountRoles(this.account_uid);

              case 2:
                roles = _context4.sent;
                userRoles = this.props.location.state.editUser.roles_uid;
                options = userRoles.map(function (item) {
                  return item._id;
                });
                selectedOptions = roles.map(function (item) {
                  var label = item.name;
                  var value = item._id;
                  return { value: value, label: label };
                });

                this.setState({ role_id: options });
                this.setState({
                  roles: selectedOptions.filter(function (item) {
                    return !item.label.startsWith('reach');
                  })
                });

                this.initialRoles = (0, _stringify2.default)(this.state.role_id);
                this.initialUser = (0, _assign2.default)({}, this.state.user);
                this.initialAgent = this.initialUser.agent || {
                  beigin_hour: 8,
                  end_hour: 17,
                  department: ""
                };
                this.unregisterRouteHook = this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave);

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function componentDidMount() {
        return _ref10.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'handleTagsChange',
    value: function handleTagsChange(tags) {
      this.setState((0, _extends3.default)({}, this.state, {
        usertags: tags.map(function (t) {
          return t.value;
        })
      }));
    }
  }, {
    key: 'handleRoleChange',
    value: function handleRoleChange(e) {
      var new_state = this.state;
      new_state.userrole = e.target.value;

      this.setState({
        new_state: new_state
      });
    }
  }, {
    key: 'handleUserSubmit',
    value: function handleUserSubmit() {
      var _this20 = this;

      var userdata = {
        first_name: this.refs.first_name.value,
        last_name: this.refs.last_name.value,
        username: this.refs.email.value,
        email: this.refs.email.value,
        msisdn: this.state.msisdn && this.state.msisdn.length === 3 ? "" : this.state.msisdn,
        tags: this.state.usertags,
        changeRole: false,
        agent: {
          available: true,
          begin_hour: this.state.begin_hour,
          end_hour: this.state.end_hour,
          department: this.refs.department.value
        }
      };
      var account_uid = this.account_uid;
      var permissions = null;
      var user_uid = this.props.location.state.editUser._id;
      var roles = this.state.role_id;

      if (this.state.rolesEdited) {
        if (roles.length > 0) {
          this.props.updateUser(user_uid, userdata).then(function () {
            _this20.props.updateUserRoles(account_uid, user_uid, roles).then(function () {
              _this20.saved = true;
              _this20.props.pushState({
                pathname: '/success',
                state: { goTo: '/users/',
                  message: (0, _translations2.default)('UPDATED USER'),
                  modal: true,
                  returnTo: '/users/'
                }
              });
            });
          });
        }
      } else {
        this.props.updateUser(user_uid, userdata).then(function () {
          _this20.saved = true;
          _this20.props.pushState({
            pathname: '/success',
            state: { goTo: '/users/',
              message: (0, _translations2.default)('UPDATED USER'),
              modal: true,
              returnTo: '/users/'
            }
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this21 = this;

      var styles = require('./User.scss');
      var classesTheme = (0, _themeEnabled.getThemeEnabledStyle)(styles);
      var hours = [].concat((0, _toConsumableArray3.default)(Array(24).keys())).map(function (hour) {
        return { value: hour, label: hour };
      });
      var isSuspended = this.state.user.status === 'SUSPENDED';

      if (__SERVER__) {
        return _react2.default.createElement(_components.VirtualListItemLoad, null);
      }

      var account = this.props.account;


      if (!account || !account.account_name) {
        return _react2.default.createElement(
          'div',
          { className: styles.loading },
          _react2.default.createElement(_components.Loading, null)
        );
      }

      return _react2.default.createElement(
        'div',
        { className: classesTheme },
        _react2.default.createElement(
          'div',
          { className: styles.userMain },
          _react2.default.createElement(
            'div',
            { className: styles.bar },
            _react2.default.createElement(
              'div',
              { className: styles.icon, onClick: this.props.router.goBack },
              _react2.default.createElement(md.arrowBack, { size: 20, color: '#FFF' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.main },
            _react2.default.createElement(_reactHelmet2.default, { title: (0, _translations2.default)('EDIT USER') }),
            _react2.default.createElement(
              'div',
              { className: styles.wrapper },
              this.state.user.federated_user && _react2.default.createElement(
                'div',
                { className: styles.alert, role: 'alert' },
                _react2.default.createElement(
                  'div',
                  { style: { display: "flex", justifyContent: "space-between", alignItems: "center" } },
                  _react2.default.createElement(md.warning, { size: 20 }),
                  _react2.default.createElement(
                    'div',
                    { style: { textAlign: "center", width: "95%" } },
                    _react2.default.createElement(
                      'h4',
                      null,
                      'Usuario federado'
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: "11px", marginTop: "-20px" } },
                  _react2.default.createElement(
                    'p',
                    null,
                    'Como usuario federado, el acceso a la plataforma est\xE1 vinculado a la autenticaci\xF3n proporcionada por la empresa o instituci\xF3n. Todo lo referente a la autenticaci\xF3n, creaci\xF3n y modificaci\xF3n de credenciales ser\xE1n manejadas por dicho sistema de autenticaci\xF3n.'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER FIRST NAME')
                  ),
                  _react2.default.createElement('input', { defaultValue: this.state.user.first_name, className: styles.input, ref: 'first_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER LAST NAME')
                  ),
                  _react2.default.createElement('input', { defaultValue: this.state.user.last_name, className: styles.input, ref: 'last_name' })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER EMAIL')
                  ),
                  _react2.default.createElement('input', { defaultValue: this.state.user.email, className: styles.disabledInput, ref: 'email', disabled: true })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.container },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('USER PHONE')
                  ),
                  _react2.default.createElement(_StyledPhoneInput2.default, {
                    key: this.props.account_info.data.available_countries,
                    countries: this.props.account_info.data.available_countries,
                    value: this.state.msisdn,
                    onChange: this.handleMsisdnChange,
                    placeholder: (0, _translations2.default)('MSISDN PLACEHOLDER'),
                    inputClass: this.state.user.allow_sms_2fa ? styles.disabledInput : styles.input,
                    disabled: this.state.user.allow_sms_2fa
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('ROLES')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    multi: true,
                    placeholder: (0, _translations2.default)('SELECT ROLES'),
                    options: this.state.roles,
                    value: this.state.role_id,
                    onChange: this.handleRoleId
                  })
                )
              ),
              _react2.default.createElement('div', { className: styles.separateForm }),
              _react2.default.createElement(
                'div',
                { className: styles.container },
                _react2.default.createElement(
                  'label',
                  { className: styles.label },
                  (0, _translations2.default)('DEPARTMENT')
                ),
                _react2.default.createElement('input', { className: styles.input, defaultValue: this.state.user.agent ? this.state.user.agent.department : "", ref: 'department' })
              ),
              _react2.default.createElement(
                'div',
                { className: styles.selectContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('START HOUR')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    value: this.state.begin_hour,
                    placeholder: (0, _translations2.default)('START HOUR'),
                    options: hours,
                    onChange: function onChange(begin_hour) {
                      return _this21.setState({ begin_hour: begin_hour.value });
                    }
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.betweenHours },
                  ' '
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.select },
                  _react2.default.createElement(
                    'label',
                    { className: styles.label },
                    (0, _translations2.default)('END HOUR')
                  ),
                  _react2.default.createElement(_reactSelect2.default, {
                    value: this.state.end_hour,
                    placeholder: (0, _translations2.default)('END HOUR'),
                    options: hours,
                    onChange: function onChange(end_hour) {
                      return _this21.setState({ end_hour: end_hour.value });
                    }
                  })
                )
              ),
              isSuspended && _react2.default.createElement(
                'span',
                { className: styles.suspendedLabel },
                ' ',
                (0, _translations2.default)('USER SUSPENDED'),
                ' '
              ),
              _react2.default.createElement('div', { className: styles.separateForm }),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'button',
                  { onClick: this.handleUserSubmit, className: (isSuspended && styles.disabledButton) + ' ' + styles.button, disabled: isSuspended },
                  (0, _translations2.default)('EDIT USER')
                ),
                isSuspended && _react2.default.createElement(
                  'button',
                  { onClick: this.handleActivateUser, className: styles.button },
                  (0, _translations2.default)('ACTIVATE USER')
                )
              )
            )
          )
        )
      );
    }
  }]);
  return EditUser;
}(_react2.default.Component), _class15.propTypes = {
  account: _propTypes2.default.object.isRequired
}, _temp5), (_applyDecoratedDescriptor(_class14.prototype, 'routerWillLeave', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class14.prototype, 'routerWillLeave'), _class14.prototype), _applyDecoratedDescriptor(_class14.prototype, 'handleTagsChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class14.prototype, 'handleTagsChange'), _class14.prototype), _applyDecoratedDescriptor(_class14.prototype, 'handleRoleChange', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class14.prototype, 'handleRoleChange'), _class14.prototype), _applyDecoratedDescriptor(_class14.prototype, 'handleUserSubmit', [_coreDecorators.autobind], (0, _getOwnPropertyDescriptor2.default)(_class14.prototype, 'handleUserSubmit'), _class14.prototype)), _class14)) || _class13) || _class13);

//#endregion